import React from 'react';

const PageTransition: React.FC<{
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}> = ({ children, className = '', style }) => (
  <div className={`animate-page-enter ${className}`} style={style}>{children}</div>
);

export default PageTransition;
